(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  const structural = [
    'section[id^="MainProduct-"]',
    '.product',
    '.product__info-wrapper',
    'product-info',
    '.product__info-container',
    '.quick-add-modal__content',
    '.quick-add-modal__content-info'
  ].join(',');

  function clean(el) {
    if (!mq.matches || !el || !(el instanceof HTMLElement)) return;
    if (!el.matches(structural)) return;
    el.classList.remove('focused');
    el.style.outline = 'none';
    el.style.boxShadow = 'none';
  }

  function cleanActive() {
    clean(document.activeElement);
    document.querySelectorAll(structural + '.focused').forEach(clean);
  }

  document.addEventListener('focusin', (e) => {
    clean(e.target);
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(cleanActive);
    setTimeout(cleanActive, 250);
    setTimeout(cleanActive, 900);
  });

  document.addEventListener('shopify:section:load', cleanActive);
})();

;(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  const interactiveSelector = [
    'a[href]',
    'button',
    'input',
    'select',
    'textarea',
    'summary',
    'label',
    '[role="button"]',
    '[role="link"]',
    '[contenteditable="true"]'
  ].join(',');

  const isInteractive = (el) => !!(el && el.matches && el.matches(interactiveSelector));

  const clearNonInteractiveFocus = (el) => {
    if (!mq.matches || !el || !(el instanceof HTMLElement) || isInteractive(el)) return;
    el.classList.remove('focused');
    el.style.outline = 'none';
    el.style.boxShadow = 'none';
    // Dawn may focus structural wrappers (e.g. dialog/product containers).
    // On mobile, release focus from those wrappers immediately.
    if (document.activeElement === el) {
      try { el.blur(); } catch (_) {}
    }
  };

  document.addEventListener('focusin', (event) => {
    clearNonInteractiveFocus(event.target);
  }, true);

  const sweep = () => {
    clearNonInteractiveFocus(document.activeElement);
    document.querySelectorAll('.focused').forEach(clearNonInteractiveFocus);
  };

  document.addEventListener('DOMContentLoaded', () => {
    requestAnimationFrame(sweep);
    setTimeout(sweep, 100);
    setTimeout(sweep, 500);
    setTimeout(sweep, 1200);
  });

  document.addEventListener('shopify:section:load', sweep);
  document.addEventListener('variant:change', () => requestAnimationFrame(sweep));
})();

;(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const setup = () => {
    document.querySelectorAll('.s15-nav-dropdown').forEach((details) => {
      if (details.dataset.s15HoverReady === '1') return;
      details.dataset.s15HoverReady = '1';
      let closeTimer;
      const open = () => {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        details.open = true;
      };
      const close = () => {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => { details.open = false; }, 140);
      };
      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', close);
      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (desktop.matches) {
            event.preventDefault();
            details.open = true;
          }
        });
      }
    });
  };
  document.addEventListener('DOMContentLoaded', setup);
  document.addEventListener('shopify:section:load', setup);
})();

;(() => {
  const hoverQuery = window.matchMedia('(hover:hover) and (pointer:fine)');
  const setupCompactNavHover = () => {
    document.querySelectorAll('.s15-mobile-nav__dropdown').forEach((details) => {
      if (details.dataset.s15CompactHover === '1') return;
      details.dataset.s15CompactHover = '1';

      let timer;
      details.addEventListener('mouseenter', () => {
        if (!hoverQuery.matches) return;
        clearTimeout(timer);
        details.open = true;
      });
      details.addEventListener('mouseleave', () => {
        if (!hoverQuery.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => { details.open = false; }, 120);
      });

      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (hoverQuery.matches) {
            event.preventDefault();
            details.open = true;
          }
        });
      }
    });
  };

  document.addEventListener('DOMContentLoaded', setupCompactNavHover);
  document.addEventListener('shopify:section:load', setupCompactNavHover);
})();

;(() => {
  const hoverCapable = window.matchMedia('(hover:hover) and (pointer:fine)');

  const closeAllExcept = (except) => {
    document.querySelectorAll('.s15-mobile-nav__dropdown[open]').forEach((item) => {
      if (item !== except) item.open = false;
    });
  };

  const setupTapDropdowns = () => {
    document.querySelectorAll('.s15-mobile-nav__dropdown').forEach((details) => {
      if (details.dataset.s15TapReady === '1') return;
      details.dataset.s15TapReady = '1';

      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        if (hoverCapable.matches) return;
        event.preventDefault();
        const willOpen = !details.open;
        closeAllExcept(details);
        details.open = willOpen;
      });

      let timer;
      details.addEventListener('mouseenter', () => {
        if (!hoverCapable.matches) return;
        clearTimeout(timer);
        closeAllExcept(details);
        details.open = true;
      });
      details.addEventListener('mouseleave', () => {
        if (!hoverCapable.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => { details.open = false; }, 140);
      });
    });

    if (document.documentElement.dataset.s15TapOutsideReady !== '1') {
      document.documentElement.dataset.s15TapOutsideReady = '1';
      document.addEventListener('click', (event) => {
        if (event.target.closest('.s15-mobile-nav__dropdown')) return;
        document.querySelectorAll('.s15-mobile-nav__dropdown[open]').forEach((item) => {
          item.open = false;
        });
      });
    }
  };

  document.addEventListener('DOMContentLoaded', setupTapDropdowns);
  document.addEventListener('shopify:section:load', setupTapDropdowns);
})();